import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
// import Logo from "../assets/logo.png";
import { Link } from "react-scroll";
import { items } from "../data/headerItems.js";
import SocialLinks from "./SocialLinks.jsx";

const Navbar = ({ isTopOfPage = true, activeSection, setActiveSection }) => {
  const [navOpen, setNavOpen] = useState(false);
  const handleClick = () => setNavOpen(!navOpen);

  const navbarBackground = !isTopOfPage ? "bg-slate-700" : "";

  return (
    <nav
      className={
        "fixed w-full z-[999] h-20 flex justify-between items-center px-7 bg-[#0a192f] text-gray-300 top-0 " +
        navbarBackground
      }
    >
      <Link
        to="home"
        smooth={true}
        duration={500}
        className="font-semibold text-3xl cursor-pointer text-primary-color"
      >
        Namaste🙏
      </Link>

      {/* menu */}
      <ul className="hidden md:flex">
        {items?.map(({ id, name }) => (
          <li
            key={id}
            className="capitalize hover:text-primary-color duration-200 hover:scale-110 font-medium"
          >
            <Link
              smooth={true}
              duration={500}
              to={name}
              className={`${
                activeSection === name ? " text-primary-color" : ""
              }`}
              onClick={() => setActiveSection(name)}
            >
              {name}
            </Link>
          </li>
        ))}
      </ul>

      {/* Hamburger */}
      <button
        onClick={handleClick}
        className="md:hidden z-10 bg-primary-color rounded-full p-2"
      >
        {!navOpen ? <FaBars size={30} /> : <FaTimes size={30} />}
      </button>

      {/* Mobile menu */}
      <ul
        className={`absolute top-0 w-2/3 duration-300 right-0 h-screen ${
          navOpen ? "right-0" : "right-[-100%] "
        } bg-[#0a192f] flex flex-col justify-center items-center`}
      >
        {items?.map(({ id, name }) => (
          <li
            key={id}
            className="capitalize py-6 text-4xl text-gray-500 hover:text-primary-color duration-200 hover:scale-110"
          >
            <Link to={name} smooth={true} duration={500} onClick={handleClick}>
              {name}
            </Link>
          </li>
        ))}
      </ul>

      {/* Social icons */}
      <SocialLinks />
    </nav>
  );
};

export default Navbar;
